<template>
  <div
    :class="[
      'field--radio',
      ...classObject,
    ]"
  >
    <InputfieldDescription :text="description" />
    <div class="field__content">
      <label
        :for="fieldId"
        class="checkLabel"
        :class="labelClass"
      >
        <input
          type="radio"
          class="field__input"
          v-bind="[$attrs, $listeners]"
          :id="fieldId"
          :name="name"
          :value="value"
          :disabled="disabled"
          :checked="isChecked"
          @change="onInput"
        >
        {{ label }}
      </label>
    </div>
    <InputfieldErrors :items="parsedErrors" />
    <InputfieldNotes :text="notes">
      <slot name="notes" />
    </InputfieldNotes>
  </div>
</template>

<script>

import InputfieldMixin from '@/components/forms/InputfieldMixin'
import InputfieldDescription from '@/components/forms/InputfieldDescription'
import InputfieldNotes from '@/components/forms/InputfieldNotes'

export default {
  name: 'InputfieldRadio',
  inheritAttrs: false,
  mixins: [
    InputfieldMixin,
  ],
  components: {
    InputfieldDescription,
    InputfieldNotes,
  },
  props: {
    model: {
      type: [String, Number, Boolean, Array],
      required: false,
      default () {
        return null
      },
    },
    value: {
      type: [String, Number, Boolean],
      required: true,
      default () {
        return null
      },
    },
  },
  model: {
    prop: 'model',
    event: 'input',
  },
  computed: {
    isChecked () {
      return this.model === this.value
    },
  },
  methods: {
    onInput () {
      this.$emit('input', this.value)
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
